// jQuery plugin to emit native events
// ===================================
//
// Native events can be received by both jQuery event listeners and native event listeners.
// jQuery events emitted by $.fn.trigger() can only be received by jQuery event listeners.
// https://makandracards.com/makandra/71890-events-triggered-by-jquery-cannot-be-observed-by-native-event-listeners
jQuery.fn.triggerNative = function(...args) {
  this.each(function() {
    up.emit(this, ...args)
  })
  return this
}
